import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { PROFESSOR_AUTHENTICATED_ENTRY } from "configs/AppConfig"
import AppRoute from "./AppRoute"
import StudentRoutes from "./StudentRoutes"
import PublicRoutes from "./PublicRoutes"
import ProfessorRoutes from "./ProfessorRoutes"
import {
  privateRoutes,
  publicRoutes,
  sharedRoutes,
  professorPrivateRoutes,
} from "configs/RoutesConfig"
import { ProfessorLayout } from "components/Layouts/Professor"
import { StudentLayout } from "components/Layouts/Student"
import { AppEmbedLayout } from "components/Layouts/AppEmbed"
import { prefixRoutes } from "common/navigationRoutes"

export default function Routers() {
  return (
    <Routes>
      {sharedRoutes?.map((route) => (
        <Route
          key={`shared-${route.key}`}
          path={route.path}
          element={
            <AppRoute routeKey={route.key} component={route.component} />
          }
        />
      ))}

      {/* Professor routes: guard → layout → pages */}
      <Route path={prefixRoutes.PROFESSOR} element={<ProfessorRoutes />}>
        <Route element={<ProfessorLayout />}>
          {professorPrivateRoutes.map((route) => (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute routeKey={route.key} component={route.component} />
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={PROFESSOR_AUTHENTICATED_ENTRY} replace />}
          />
        </Route>
      </Route>

      {/* Embed App routes */}
      <Route path="/" element={<StudentRoutes />}>
        <Route element={<AppEmbedLayout />}>
          {privateRoutes.map((route, index) => {
            const embedPath = route.path.startsWith("/")
              ? `${prefixRoutes.EMBED}${route.path}`
              : `${prefixRoutes.EMBED}/${route.path}`
            return (
              <Route
                key={`embed-${route.key}`}
                path={embedPath}
                element={
                  <AppRoute
                    routeKey={`embed-${route.key}`}
                    component={route.component}
                  />
                }
              />
            )
          })}
        </Route>
      </Route>

      {/* Student routes */}
      <Route path="/" element={<StudentRoutes />}>
        <Route element={<StudentLayout />}>
          {privateRoutes.map((route, index) => {
            return (
              <Route
                key={route.key}
                path={route.path}
                element={
                  <AppRoute routeKey={route.key} component={route.component} />
                }
              />
            )
          })}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>

      <Route path="/" element={<PublicRoutes />}>
        {publicRoutes.map((route, index) => {
          return (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute routeKey={route.key} component={route.component} />
              }
            />
          )
        })}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Route>
    </Routes>
  )
}
